import {Controller} from '@hotwired/stimulus'

export default class extends Controller {
  connect () {
    // Find the form element
    this.form = this.element.querySelector('form')

    if (!this.form) {
      console.error('Form element not found in episode-form controller')
    }
  }

  submitForm (event) {
    event.preventDefault()

    // Check if TOTP verification is needed
    const currentAdminHasTotp = this.element.dataset.currentAdminTotpEnabled === 'true'

    if (currentAdminHasTotp) {
      this.showTotpModal()
    } else {
      this.submitFormDirectly()
    }
  }

  showTotpModal () {
    const formData = this.getFormData()

    const event = new CustomEvent('showTotpModal', {
      detail: {
        actionUrl: this.getActionUrl(),
        actionMethod: this.getActionMethod(),
        formData: formData
      }
    })
    document.dispatchEvent(event)
  }

  submitFormDirectly () {
    if (this.form) {
      this.form.submit()
    } else {
      console.error('Form element not found')
    }
  }

  getFormData () {
    if (!this.form) {
      console.error('Form element not found')
      return {}
    }

    const formData = new FormData(this.form)
    const data = {}

    for (let [key, value] of formData.entries()) {
      if (key.includes('[') && key.includes(']')) {
        // Handle nested parameters like episode[audio_content_attributes][audio]
        const matches = key.match(/^(\w+)\[(\w+)\](\[\])?$/)
        if (matches) {
          const parent = matches[1]
          const child = matches[2]
          const isArray = matches[3] === '[]'

          if (!data[parent]) data[parent] = {}
          if (isArray) {
            if (!data[parent][child]) data[parent][child] = []
            data[parent][child].push(value)
          } else {
            data[parent][child] = value
          }
        } else {
          // Handle more complex nested structures
          data[key] = value
        }
      } else {
        data[key] = value
      }
    }

    return data
  }

  getActionUrl () {
    if (!this.form) {
      console.error('Form element not found')
      return ''
    }
    return this.form.action
  }

  getActionMethod () {
    if (!this.form) {
      console.error('Form element not found')
      return 'PATCH'
    }
    // For Rails forms, check the _method field or use PATCH for updates
    const methodField = this.form.querySelector('input[name="_method"]')
    if (methodField) {
      return methodField.value.toUpperCase()
    }
    if (this.form.method) {
      return this.form.method.toUpperCase()
    }
    return 'PATCH'
  }
}
